var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.383-50-50-50h-300c-27.6172 0-50 22.3828-50 50v380c0 27.617 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.383-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.059 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#006bb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.383-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.059 17.9414 40 40 40z",
    fill: "#015ea4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.789v96.789z",
    fill: "#015ea4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.383-50 50v60h110z",
    fill: "#669ac1"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.9805 417.695h14.7855l10.808-34.582 10.813 34.582h14.258l7.421-57.695h-11.836l-5.097 40.605-12.695-40.605h-5.645l-13.035 40.957-4.817-40.957h-12.0387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.324 406.797c-4.832.098-8.726-1.582-11.687-5-2.957-3.438-4.434-7.852-4.434-13.281 0-5.118 1.504-9.375 4.524-12.735 3.015-3.379 6.824-5.058 11.421-5.058 4.836 0 8.743 1.66 11.711 4.992 2.969 3.316 4.461 7.703 4.461 13.152 0 5.371-1.453 9.668-4.375 12.93-2.918 3.242-6.785 4.922-11.621 5zm-29.09-17.93c0 8.535 2.813 15.567 8.457 21.121 5.645 5.551 12.325 8.332 20.059 8.332 8.555 0 15.637-2.793 21.23-8.379 5.594-5.578 8.399-12.636 8.399-21.152 0-8.476-2.774-15.508-8.313-21.094-5.535-5.605-12.507-8.398-20.918-8.398-8.406 0-15.332 2.781-20.757 8.348-5.442 5.57-8.157 12.648-8.157 21.222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.316 417.695h12.59l14.59-38.359 14.617 38.359h12.61l-21.844-57.695h-10.805z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m263.289 170.801c4.289-13.106 18.359-20.305 31.508-16.016 13.125 4.258 20.308 18.352 16.043 31.485-4.277 13.105-18.367 20.293-31.504 16.035-13.113-4.278-20.293-18.367-16.047-31.504zm-12.723-39.121c-11.152-8.125-13.64-23.75-5.515-34.9339 8.113-11.1719 23.738-13.6406 34.922-5.5234 11.148 8.1132 13.632 23.7503 5.523 34.9293-8.125 11.153-23.75 13.633-34.93 5.528zm-41.14 0c-11.172 8.105-26.809 5.633-34.922-5.535-8.117-11.172-5.637-26.8091 5.523-34.9223 11.172-8.1094 26.809-5.625 34.934 5.5234 8.105 11.1839 5.625 26.8089-5.535 34.9339zm-12.727 39.14c4.27 13.118-2.922 27.227-16.047 31.485-13.132 4.265-27.222-2.918-31.492-16.043-4.258-13.117 2.93-27.231 16.043-31.496 13.125-4.258 27.231 2.929 31.496 16.054zm33.301 24.18c13.809 0 25 11.191 25 25s-11.191 25-25 25-25-11.191-25-25 11.191-25 25-25zm0-55c11.047 0 20 8.953 20 20s-8.953 20-20 20-20-8.953-20-20 8.953-20 20-20zm-100 20c0 55.227 44.773 100 100 100s100-44.773 100-100-44.773-100-100-100-100 44.773-100 100",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.707 80c-8.125 0-14.707 6.582-14.707 14.707v45.293h-20v-50c0-16.5703 13.43-30 30-30h40v20z",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMov);
export default __webpack_public_path__ + "static/media/mov.d587ab10e5c6e4e124f48f52422aa384.svg";
export { ForwardRef as ReactComponent };